import { memo } from 'react';
import BigPlayButton from './BigPlayButton';

export default memo(BigPlayButton);
